export const ORDER_STATUS = {
  DRAFT: 0,
  SUBMITTED: 10,
  CONFIRMED: 30,
  CLOSED: 40,
  CANCELLED: 80,
};
